"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * This hook facilitates usage of multiple refs in concert with each other
 * @param  {...any} refs Accepts one or more refs to link
 * @returns {object or function} Returns a new ref that will update each linked ref any time one ref changes
 */
var useCombinedRefs = function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  // create an intermediary ref
  var targetRef = (0, _react.useRef)();
  // bubble changes up to each linked ref whenever intermediary updates
  (0, _react.useEffect)(function () {
    for (var i = 0; i < refs.length; i++) {
      var ref = refs[i];
      if (!ref) return;
      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    }
  }, [refs]);
  // use this ref in your target component to link your additional refs
  return targetRef;
};
useCombinedRefs.PropTypes = {
  /**
   * An array of refs to synchronize
   */
  refs: _propTypes["default"].array
};
var _default = exports["default"] = useCombinedRefs;